import { render } from "./Viwerjs.vue?vue&type=template&id=08589050&class=teste"
import script from "./Viwerjs.vue?vue&type=script&lang=js"
export * from "./Viwerjs.vue?vue&type=script&lang=js"

import "./Viwerjs.vue?vue&type=style&index=0&id=08589050&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__